import React from "react";
import {ColumnLayout, Input, Select} from "@amzn/awsui-components-react";

export class RoundCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {...this.props.data};
  }

  handleChange = (change, e) => {
    const newState = {};
    newState[change] = e.detail.selectedId;
    this.setState(newState, () => {
      this.props.onChange({...this.state});
    });
  }

  handleNumberValueChange = (change, e) => {
    const newState = {};
    newState[change] = parseInt(e.detail.value);
    this.setState(newState, () => {
      this.props.onChange({...this.state});
    });
  }

  render() {
    const selection = this.props.columns.filter(x => x[1] === this.props.data.column_name);
    return <ColumnLayout columns={3}>
      <div data-awsui-column-layout-root="true">
        <div style={{marginTop: "25px"}}>
          Select final value and round appropriate for insertion into Virtual Trader
        </div>
        <div>
          Column:
          <Select options={this.props.columns.map((x, ind) => {
            return {label: x[0], id: x[1]};
          })}
                  selectedOption={{
                    label: selection.length > 0? selection[0][0]: "",
                    id: selection.length > 0? selection[0][0]: "",
                  }}
                  onChange={(e) => this.handleChange('column_name', e)}
                  selectedLabel="Selected"
                  filteringType={"auto"}
                  disabled={this.props.disabled}/>
        </div>
        <div>
          Number of decimals to round to:
          <Input value={this.props.data.decimals + ""}
                 type={"number"}
                 onChange={(e) => this.handleNumberValueChange('decimals', e)}
                 disabled={this.props.disabled}/>
        </div>
      </div>
    </ColumnLayout>;
  }
}
